import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import Player from '@vimeo/player';
import { DomSanitizer } from '@angular/platform-browser';
import { PageService } from 'src/app/services/page.service';
@Component({
    selector: 'app-banner-module-video',
    templateUrl: './banner-module-video.component.html',
    styleUrls: ['./banner-module-video.component.scss']
})
export class BannerModuleVideoComponent implements OnInit {
    @Input() videoid: number;
    @Input() returncolorvalue: string;
    @Input() returnbuttoncolorvalue: string;
    @Input() i: number;
    @Input() randomImage: any;
    @Input() textColor: any;
    @Input() subtitle: any;
    @Input() title: any;
    @Input() contentAlign: any;
    player: Player;
    clickPause = false;
    clickPlay = true;
    hiddeButton = false;
    showVideo = false;
    startVideo = false;
    durationTimer = false;
    videoprogress: number = 0;
    secondprogress: number = 0;
    minuteprogress: number = 0;
    totalminuteduration: number = 0;
    totalsecondduration: number = 0;
    progresstime: number = 0;
    screenWidth: number;
    screenHeight: number;
    videoActive = false;
    videoUrl: any;
    dangerousVideoUrl: any;
    dangerousUrl: any;
    trustedUrl: any;
    playVideoMobile: boolean = false;
    activeVideoOnMobile = false;
    playerMobile: Player;
    videoUrlMobile: any;
    videoPaused: boolean = false;
    body = document.getElementsByTagName('body')[0];
    html = document.getElementsByTagName('html')[0];
    menu = document.getElementsByClassName('toggle-button-container')[0];
    cursor = document.querySelector('.cursor');

    @ViewChild('videoplayer') videoplayer: ElementRef;
    @ViewChild('videoplayermobile') videoplayermobile: ElementRef;
    @Output() onPlayContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPauseContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPlayVideo: EventEmitter<any> = new EventEmitter<any>();
    @Output() onExitVideo: EventEmitter<any> = new EventEmitter<any>();

    constructor(private sanitizer: DomSanitizer,
        private pageService: PageService) {
        this.dangerousUrl = 'javascript:alert("Video Error")';
        this.trustedUrl = sanitizer.bypassSecurityTrustUrl(this.dangerousUrl);
        this.onResize(event);

        this.pageService.pauseBannerVideoListen().subscribe(() => {
            this.pause();
        })

    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if (this.playVideoMobile && window.innerWidth > 768) {
            this.screenWidth = 768;
        }
    }

    ngOnInit() {
    }

    activeVideo() {
        if (this.screenWidth <= 1024) {
            this.body.classList.add('body-noscroll');
            this.html.classList.add('overflow-hidden');
            this.pageService.mobileVideoPlaying(true);
            this.playVideoMobile = true;
            this.videoUrlMobile = '';
            this.activeVideoOnMobile = true;
            this.dangerousUrl = 'https://player.vimeo.com/video/' + this.videoid + '?autoplay=0&loop=1&autopause=0&background=0&byline=0&portrait=0&muted=0&fullscreen=1';
            this.videoUrlMobile = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrl);
            setTimeout(() => {
                this.playMobile();
            }, 1000);
        } else {
            this.videoUrl = '';
            this.onPauseContent.emit();
            this.videoActive = true;
            this.dangerousVideoUrl = 'https://player.vimeo.com/video/' + this.videoid + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=0&fullscreen=1';
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousVideoUrl);
            setTimeout(() => {
                this.player = new Player(this.videoplayer.nativeElement);
                this.play();
            }, 1000);
        }
    }

    play() {
        this.onPauseContent.emit();
        this.onPlayVideo.emit();
        this.player.play();
        this.player.clickPlay = false;
        this.player.clickPause = true;
        this.player.clickReplay = true;
        this.showVideo = true;
        this.startVideo = true;
        this.hiddeButton = true;
        this.videoPaused = false;
        setTimeout(() => {
            this.hiddeButton = false;
        }, 1000);
        this.player.on('timeupdate', function (data) {
            this.videoprogress = (data.percent * 100);

            this.minuteprogress = Math.floor(data.seconds / 60);
            this.minuteprogress = ('0' + this.minuteprogress).slice(-2);
            this.secondprogress = Math.floor(data.seconds) - this.minuteprogress * 60;
            this.secondprogress = ('0' + this.secondprogress).slice(-2);

            this.totalminuteduration = Math.floor(data.duration / 60);
            this.totalminuteduration = ('0' + this.totalminuteduration).slice(-2);
            this.totalsecondduration = Math.floor(data.duration) - this.totalminuteduration * 60;
            this.progresstime = Math.floor(data.duration);
            this.totalsecondduration = ('0' + this.totalsecondduration).slice(-2);
            this.seekbarproggress = (data.seconds / data.duration) * 100;
        });
        this.player.on('ended', function (data) {
            this.clickReplay = false;
            this.clickPlay = true;
            this.onPlayContent.emit();
        });
        if (this.durationTimer == true) {
            this.durationTimer = false;
        }
        setTimeout(() => {
            this.hiddeButton = true;
        }, 2000);
    }

    playMobile() {
        this.playerMobile = new Player(this.videoplayermobile.nativeElement);
        this.playerMobile.play();
        this.playerMobile.on('timeupdate', function (data) {
            this.videoprogress = (data.percent * 100);

            this.minuteprogress = Math.floor(data.seconds / 60);
            this.minuteprogress = ('0' + this.minuteprogress).slice(-2);
            this.secondprogress = Math.floor(data.seconds) - this.minuteprogress * 60;
            this.secondprogress = ('0' + this.secondprogress).slice(-2);

            this.totalminuteduration = Math.floor(data.duration / 60);
            this.totalminuteduration = ('0' + this.totalminuteduration).slice(-2);
            this.totalsecondduration = Math.floor(data.duration) - this.totalminuteduration * 60;
            this.progresstime = Math.floor(data.duration);
            this.totalsecondduration = ('0' + this.totalsecondduration).slice(-2);
            this.seekbarproggress = (data.seconds / data.duration) * 100;
        });
        this.playerMobile.on('ended', function (data) {
            this.clickReplay = false;
            this.clickPlay = true;
        });
    }

    pause() {
        this.videoPaused = true;
        this.onPlayContent.emit();
        if (this.player) {
            this.player.pause();
            this.player.clickPause = false;
            this.player.clickPlay = true;
        }
        this.durationTimer = true;
    }

    replay() {
        this.play();
        this.onPauseContent.emit();
    }

    close() {
        this.videoUrl = '';
        this.onPlayContent.emit();
        this.onExitVideo.emit();
        this.videoActive = false;
    }

    exitVideoMobile() {
        this.html.classList.remove('overflow-hidden');
        this.body.classList.remove('body-noscroll');
        this.videoUrlMobile = '';
        this.onPlayContent.emit();
        this.onExitVideo.emit();
        this.playVideoMobile = false;
        this.pageService.mobileVideoPlaying(false);
    }

    seekOutside(event) {
        var pct = Math.floor((event.offsetX / this.screenWidth) * 100);
        let timeVal = (pct * this.player.progresstime) / 100;
        this.player.setCurrentTime(timeVal);
        this.player.play();
        this.player.clickPlay = false;
        this.player.clickPause = true;
        this.player.clickReplay = true;
    }
}
